import { render, staticRenderFns } from "./CreatePharmacy.vue?vue&type=template&id=48015c24"
import script from "./CreatePharmacy.vue?vue&type=script&lang=js"
export * from "./CreatePharmacy.vue?vue&type=script&lang=js"
import style0 from "./CreatePharmacy.vue?vue&type=style&index=0&id=48015c24&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48015c24')) {
      api.createRecord('48015c24', component.options)
    } else {
      api.reload('48015c24', component.options)
    }
    module.hot.accept("./CreatePharmacy.vue?vue&type=template&id=48015c24", function () {
      api.rerender('48015c24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/PharmacyComponent/CreatePharmacy.vue"
export default component.exports